import {makeStyles} from '@material-ui/core';

export const useStyles=makeStyles({
    root:{
       display: 'flex',
       flexDirection:'column',
       justifyContent:'center',
       alignItems:'center',
       minHeight:'100vh',
       background:'linear-gradient(to bottom right,rgba(33, 9, 78,0.6),#4CA1A3,rgba(81, 18, 129,0.6),#45E1AD)',
       width:'100%'
    },
    scoreBox:{
        display: 'flex',
        alignItems:'center',
        marginBottom:'30px'
    },
    paper:{
        padding:'10px'
    },
    tableHead:{
        background:'linear-gradient(to right,#4CA1A3,#45E1AD)'
    },
    tableRow:{
        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.5)'
    },
    title:{
        marginBottom:'10px'
    },
    tableContainer:{
        padding:'5px'
    }
})